import { add, listen, qsa, qs, remove } from "@fluorescent/dom";
import { emit } from "@/glow/events";
import { cart } from "@/glow";
import Carousel from "@/lib/carousel";

const selectors = {
  crossSellsSlider: "[data-cross-sells-slider]",
  quickViewTrigger: "[data-quick-view-trigger]",
  addToCartTrigger: "[data-add-item-id]",
};

export default function CrossSells(node) {
  const { crossSellsSlider } = qs(selectors.crossSellsSlider, node).dataset;

  let swiper =
    crossSellsSlider === "true"
      ? new Carousel(node, { slidesPerView: 1.15, spaceBetween: 8 })
      : null;

  const events = [
    listen(qsa(selectors.quickViewTrigger, node), "click", e => {
      const { productUrl } = e.target.dataset;
      if (!productUrl) return;

      emit("quick-view:open", null, {
        productUrl: productUrl,
      });
    }),
    listen(qsa(selectors.addToCartTrigger, node), "click", e => {
      const buttonEl = e.target;
      add(buttonEl, "loading");

      const { addItemId } = e.target.dataset;
      if (!addItemId) return;

      const minQuantity = buttonEl.getAttribute("data-quantity-minimum");

      cart.addItemById(addItemId, minQuantity).then(
        () => {
          remove(buttonEl, "loading");
          emit("quick-cart:scrollup");
        },
        error => {
          console.error(error);
          remove(buttonEl, "loading");
          alert(error.message);
        }
      );
    }),
  ];

  function unload() {
    events.forEach(unsubscribe => unsubscribe());
    swiper?.destroy();
  }

  return { unload };
}
